export class PetMatabolicModel {
    pet_no: number
    tag7: string
    tag8: string
    tag9: string
    tag9bis: string
    _tag9: string
    _tag9bis: string
    tag10: string
    tag11: string
    tag14: string
    tag12: string
    tag13: string
    tag18: string
    tag15: string
    tag16: string
    tag17: string
    tag19: string
    tag20: string
    tag21: string
    tag22: string
    tag23: string
    tag24: string
    tag25: string

    constructor(
        pet_no: number,
        tag7: string,
        tag8: string,
        tag9: string,
        tag9bis: string,
        tag10: string,
        tag11: string,
        tag14: string,
        tag12: string,
        tag13: string,
        tag18: string,
        tag15: string,
        tag16: string,
        tag17: string,
        tag19: string,
        tag20: string,
        tag21: string,
        tag22: string,
        tag23: string,
        tag24: string,
        tag25: string
    ) {
        this.pet_no = pet_no
        this.tag7 = tag7
        this.tag8 = tag8
        this.tag9 = tag9
        this.tag9bis = tag9bis
        this.tag10 = tag10
        this.tag11 = tag11
        this.tag14 = tag14
        this.tag12 = tag12
        this.tag13 = tag13
        this.tag18 = tag18
        this.tag15 = tag15
        this.tag16 = tag16
        this.tag17 = tag17
        this.tag19 = tag19
        this.tag20 = tag20
        this.tag21 = tag21
        this.tag22 = tag22
        this.tag23 = tag23
        this.tag24 = tag24
        this.tag25 = tag25
    }
}